import React, { useEffect, useState } from "react";
import { Activity } from "lucide-react";
import api from "../../lib/api";

export default function AdminActivity() {
  const [entries, setEntries] = useState(null);
  const [filter, setFilter] = useState("");

  useEffect(() => {
    const params = filter ? `?action_prefix=${filter}` : "";
    api.get(`/admin/activity${params}`).then((r) => setEntries(r.data)).catch(() => setEntries([]));
  }, [filter]);

  const FILTERS = ["", "order", "coupon", "stock", "user"];

  return (
    <div data-testid="admin-activity">
      <div className="overline text-zinc-500">Audit</div>
      <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight mb-2">Activity log</h1>
      <p className="text-sm text-zinc-500 mb-6">
        Every meaningful change made by staff or admins is logged here for accountability.
      </p>

      <div className="flex gap-2 mb-4 flex-wrap">
        {FILTERS.map((f) => (
          <button key={f || "all"} onClick={() => setFilter(f)}
                  className={`px-3 py-1.5 text-xs font-semibold rounded-full border transition ${
                    filter === f ? "bg-[#F74B64] text-white border-[#F74B64]" : "bg-white text-zinc-600 border-zinc-200 hover:border-zinc-400"
                  }`} data-testid={`activity-filter-${f || "all"}`}>
            {f === "" ? "All" : f}
          </button>
        ))}
      </div>

      {entries === null ? (
        <div className="text-sm text-zinc-500">Loading…</div>
      ) : entries.length === 0 ? (
        <div className="rounded-xl border border-dashed border-zinc-200 p-10 text-center">
          <Activity size={28} className="mx-auto text-zinc-300 mb-3" />
          <p className="text-sm text-zinc-500">No activity recorded yet.</p>
        </div>
      ) : (
        <div className="rounded-xl border border-zinc-200 bg-white overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm min-w-[700px]">
              <thead className="bg-zinc-50 text-zinc-500 text-xs">
                <tr>
                  <th className="text-left px-4 py-3">When</th>
                  <th className="text-left px-4 py-3">Who</th>
                  <th className="text-left px-4 py-3">Action</th>
                  <th className="text-left px-4 py-3">Target</th>
                  <th className="text-left px-4 py-3">Details</th>
                </tr>
              </thead>
              <tbody>
                {entries.map((e) => (
                  <tr key={e.id} className="border-t border-zinc-100" data-testid={`activity-${e.id}`}>
                    <td className="px-4 py-3 text-xs text-zinc-500 whitespace-nowrap">{new Date(e.created_at).toLocaleString()}</td>
                    <td className="px-4 py-3">
                      <div className="font-semibold text-sm">{e.user_name || "—"}</div>
                      <div className="text-[10px] text-zinc-400">{e.user_role || "—"}</div>
                    </td>
                    <td className="px-4 py-3"><code className="text-xs bg-zinc-100 px-1.5 py-0.5 rounded">{e.action}</code></td>
                    <td className="px-4 py-3 text-xs text-zinc-500">
                      {e.entity_type}{e.entity_id ? ` · ${e.entity_id.slice(0, 8)}` : ""}
                    </td>
                    <td className="px-4 py-3 text-xs">
                      {e.details && Object.keys(e.details).length > 0 && (
                        <code className="text-[10px] text-zinc-500 break-all">
                          {JSON.stringify(e.details)}
                        </code>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
